import { colors } from '../../colors';
var address = {
  addressColor: colors.black
};
export default address;